import { AfterViewInit, Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';

declare const URS: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.less']
})
export class LoginComponent implements AfterViewInit {
  questionRandomString: string;
  i18nPrefix = 'login.';
  // extraData = {
  //   task_title: '测试任务',
  //   contact_person: '张三'
  // };
  extraData;
  i18nPrefixTwo = 'question.';
  isMobileDuplicated = false;
  constructor(
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngAfterViewInit() {
    // 获取等下要跳转的路由
    this.activatedRoute.queryParams.subscribe(params => {
      console.log('params: ', params);
      this.questionRandomString = params['questionRandomString'];
    })

    const self = this;
    const config = {
      newCDN: 1, // 代表使用的CDN是连通性更好的SNI域名
      version: 4, // 代表版本4
      cssDomain: '',
      cssFiles: 'index-demo3.css',
      includeBox: 'login', // 必须，登陆框的外层节点的id
      product: 'crowdsource', // 产品ID
      promark: 'hPwgAPR', // 组件ID
      host: 'testopia-public.netease.com', // 组件所在域名
      cookieDomain: 'netease.com',
      regCookieDomain: 'netease.com',
      single: 1, // 是否只用一个模块，1是，0否
      page: 'login', // 首屏
      gotoRegText: '免费注册网易邮箱帐号',
      needMobileLogin: 1,
      mobileFirst: 1,
      smsLoginFirst: 1,
      "uniteLogin": {
        "isItl": 0,
        "first": 1,
        "needUnLogin": 0,
        "unLoginTime": 10,
        "preFillUnite": "",
        "unLoginTxt": "十天内免登录"
      },
      regcb: function (username) {
        console.log('注册完成')
      },
      logincb: function (_username, _isOther, _data) {
        console.log('登录完成')
        setTimeout(() => {
          self.loginComplete();
        });
      },
      closecb: function () {
        console.log('用户放弃操作');
      },
      changepage: function (page) {
        const spanDom = document.getElementById("otherLogin");
        if (page === 'register') {
          spanDom.style.display = 'none';
        } else if (page === 'login') {
          spanDom.style.display = 'block';
        }
      },
      style: `
      #cnt-box{
        padding-top: 50px;
      }
      .m-header{
        display: none;
      }
      @media screen and (max-width: 1200px) {
        .m-pcbox{
          height: 46px;
        }
    
        .m-pcbox .inputbox {
          width: calc(100% - 135px);
        }
    
        .g-bd {
          width: 100% !important;
        }
        .m-cnt {
          padding: 0 0 !important;
        }
        .m-cnt .inputbox {
          overflow:hidden;
        }
    
        .u-tab{
          display: none;
        }
    
    
        .m-cnt .m-nerror .ferrorhead, .m-cnt .m-nerror .ferrorhead2, .m-cnt .m-nerror .ferrorhead3, .m-cnt .m-nerror .ferrorhead4{
          width: 90%;
        }
    
        .forgetpwdReg{
          display: none;
        }

        .m-cnt .pcbtn a{
          background: #E8503A;
        }
     
        .btncolor{
          background: #E8503A;
          border-radius:100px;
        }
    
    
        .loginbox {
          margin-top: 36px;
        }
      }
      `
    }
    const urs = new URS(config);
  }


  loginComplete() {
    const data = {
      loginSource: 'public_web',
      surveyRandomString: this.questionRandomString
    }

    this.userService.loginComplete(data).subscribe(res => {
      console.log('登录完成', res);
      this.userService.getUserInfo();
      if (this.questionRandomString) {
        this.router.navigate(['/question', this.questionRandomString]);
      }
    }, err => {
      console.error('登录失败', err);
      // 问卷登录白名单拦截
      if (err.error && err.error.msg && err.error.msg === 'survey_no_permission') {
        this.isMobileDuplicated = false;
        this.extraData = err.error.extra_data;
      }else if(err.error && err.error.msg && err.error.msg === 'mobile_duplicated'){
        this.isMobileDuplicated = true;
        this.extraData = err.error.extra_data;
      }else{
        this.isMobileDuplicated = false;
        this.extraData = null;
      }
    })
  }

}
